import React, { useState, useEffect } from 'react';
import './DynamicBackground.css';

// Import background images
import bg1 from '../assets/backgrounds/waldhorn_dark_pitch_black_glitched_lawyer_collage_lady_justic_6095ac8a.png';
import bg3 from '../assets/backgrounds/waldhorn_dark_pitch_black_glitched_lawyer_collage_lady_justic_5a7285ef.png';
import bg4 from '../assets/backgrounds/waldhorn_dark_pitch_black_glitched_lawyer_collage_lady_justic_c45756d1.png';
import bg5 from '../assets/backgrounds/waldhorn_dark_pitch_black_glitched_lawyer_collage_lady_justic_a47bc7a3.png';
import bg6 from '../assets/backgrounds/waldhorn_dark_pitch_black_glitched_lawyer_collage_lady_justic_d39d4206.png';
import bg7 from '../assets/backgrounds/waldhorn_dark_pitch_black_glitched_lawyer_collage_lady_justic_10faa432 (1).png';

const backgroundImages = [bg1, bg3, bg4, bg5, bg6, bg7];

interface DynamicBackgroundProps {
  children: React.ReactNode;
  className?: string;
}

const DynamicBackground: React.FC<DynamicBackgroundProps> = ({ children, className = '' }) => {
  const [currentBgIndex, setCurrentBgIndex] = useState(0);

  useEffect(() => {
    // Select a random background image on component mount
    const randomIndex = Math.floor(Math.random() * backgroundImages.length);
    setCurrentBgIndex(randomIndex);
  }, []);

  const currentBackground = backgroundImages[currentBgIndex];

  return (
    <div 
      className={`dynamic-background ${className}`}
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.8)), url(${currentBackground})`
      }}
    >
      {children}
    </div>
  );
};

export default DynamicBackground; 